<template>
  <div class="table-responsive">
    <table
      class="table table-hover table-striped table-sm fs-sm"
      :id="dataTable.id"
    >
      <thead>
        <tr>
          <th>Nome</th>
          <th>Cliente</th>
          <th>Ticket</th>
          <th>Aderência</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, key) in data.details" :key="key">
          <td>{{ item.name }}</td>
          <td>{{ item.organization }}</td>
          <td>{{ item.ticketId }}</td>
          <td>{{ item.status }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { dateTimeSqlToDateTimeBR } from '@/utils/date'
import '@/utils/basicDataTableExtend'

export default {
  name: 'DetailsGrip',

  props: {
    data: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      dateTimeSqlToDateTimeBR,
      dataTable: {
        id: 'datatableDetailsGrip',
        order: [[2, 'DESC']],
      },
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }
      this.table = window.$(`#${this.dataTable.id}`).DataTable(this.dataTable)
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
